import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { removeToast, setToast } from '../core.actions';
import { filter, map, switchMap } from 'rxjs/operators';
import { timer } from 'rxjs';

@Injectable()
export class ToastEffects {
  autoCloseToast$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setToast),
      filter(({ toast }) => toast.duration > 0),
      switchMap(({ toast }) =>
        timer(toast.duration).pipe(
          map(() => {
            return removeToast({ id: toast.id });
          }),
        ),
      ),
    ),
  );
  constructor(private readonly actions$: Actions) {}
}
